import React from 'react'
import './style.css'
import { Button } from '../Button'



export const Question = ({ question, toggleQuestion, loading, sendQuestion, saved }) => {
    return (
        <div className='Question'>
            <div>
            <div className='Question__blocktitle'>У нас есть несколько вопросов:</div>
                <div className='Question__item'>
                    <div className='Question__title'>
                        Есть ли у вас особые предпочтения по еде?
                    </div>
                    <div>
                        <label className="Question__container">Не ем мясо
                            <input type="checkbox" name='food_no_meat' checked={question?.food_no_meat === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>
                        <label className="Question__container">Не ем рыбу
                            <input type="checkbox" name='food_no_fish' checked={question?.food_no_fish === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>
                        <label className="Question__container">Вегетарианец
                            <input type="checkbox" name='food_veg' checked={question?.food_veg === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>
                    </div>
                </div>
                <div className='Question__item'>
                    <div className='Question__title'>
                        Что будете пить?
                    </div>
                    <div>
                        <label className="Question__container">Белое вино
                            <input type="checkbox" name='alko_white_wine' checked={question?.alko_white_wine === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>
                        <label className="Question__container">Красное вино
                            <input type="checkbox" name='alko_red_wine' checked={question?.alko_red_wine === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>
                        <label className="Question__container">Шампанское
                            <input type="checkbox" name='alko_champagne' checked={question?.alko_champagne === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>
                        <label className="Question__container">Виски
                            <input type="checkbox" name='alko_whisky' checked={question?.alko_whisky === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>
                        <label className="Question__container">Коньяк
                            <input type="checkbox" name='alko_cognac' checked={question?.alko_cognac === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>
                        <label className="Question__container">Коктейли
                            <input type="checkbox" name='alko_cocktails' checked={question?.alko_cocktails === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>
                        <label className="Question__container">Сок/компот
                            <input type="checkbox" name='juice' checked={question?.juice === '1'} onChange={toggleQuestion} />
                            <span className="Question__checkmark_checkbox"></span>
                        </label>                        
                    </div>
                </div> 
                <div className='Question__item'>
                    <div className='Question__title'>
                        Хотите ли вы поздравить нас публично?
                    </div>
                    <div>
                        <label className="Question__container">Конечно!
                            <input type="radio" name="congratulations" checked={question?.congratulations === '1'} onChange={toggleQuestion} value={'1'} />
                            <span className="Question__checkmark_radio"></span>
                        </label>
                        <label className="Question__container">Я стесняюсь, но поздравлю с компанией
                            <input type="radio" name="congratulations" checked={question?.congratulations === '2'} onChange={toggleQuestion} value={'2'} />
                            <span className="Question__checkmark_radio"></span>
                        </label>
                        <label className="Question__container">Я очень-очень стесняюсь, лучше поздравлю лично
                            <input type="radio" name="congratulations" checked={question?.congratulations === '0'} onChange={toggleQuestion} value={'0'} />
                            <span className="Question__checkmark_radio"></span>
                        </label>
                    </div>
                </div>               
                <div className='Question__item'>
                    <div className='Question__title'>
                        Есть ли у вас пищевая аллергия? На что?
                    </div>
                    <textarea name='allergy' value={question?.allergy} onChange={toggleQuestion} maxLength={2000}/>
                </div>
                <div className='Question__item'>
                    <div className='Question__title'>
                        Есть особые пожелания?
                    </div>
                    <textarea name='wishes' value={question?.wishes} onChange={toggleQuestion} maxLength={2000}/>
                </div>
                <Button loading={loading} onClick={!saved ? sendQuestion : () => { }} mode={saved && 'success'}>{saved ? 'Сохранено' : 'Сохранить'}</Button>
            </div>
        </div>
    )
}
